import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import landingPageimage2 from "../assets/landingPage/landingPage2.jpg";
import landingPageimageMobileSmartbuilding from "../assets/landingPage/landingPageMobileSmartbuilding.jpg";
import landingPageimageMobileSmarthome from "../assets/landingPage/landingPageMobileSmarthome.jpg";
import goLeftIcon from "../assets/landingPage/goLeft.png";
import goRightIcon from "../assets/landingPage/goRight.png";
import textContentLandingPage from "./homePage-textContent";

function SmarthomePage() {
  const language = useSelector((state) => state.dictionary.language);
  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <>
      {!isMobile ? (
        <div className="landing-page">
          <div className="landing-page-image" aria-hidden="true">
            <div className="landing-page-title">
              <h1>{textContentLandingPage.landingPage.title[language]}</h1>
              <h2>{textContentLandingPage.landingPage.subtitle[language]}</h2>
            </div>

            <div className="landing-page-text">
              <Link to="/smarthome" className="landing-nav-button left">
                <img src={goLeftIcon} aria-hidden="true" />
                <h2
                  className="landing-nav-button-text"
                  dangerouslySetInnerHTML={{
                    __html:
                      textContentLandingPage.landingPage.domain.smarthome[
                        language
                      ],
                  }}
                />
              </Link>
              <Link to="/smartbuilding" className="landing-nav-button">
                <h2
                  className="landing-nav-button-text"
                  dangerouslySetInnerHTML={{
                    __html:
                      textContentLandingPage.landingPage.domain.smartbuilding[
                        language
                      ],
                  }}
                />
                <img src={goRightIcon} aria-hidden="true" />
              </Link>
            </div>
            <img src={landingPageimage2} aria-hidden="true" />
          </div>
        </div>
      ) : (
        <div className="landing-page">
          <div className="landing-page-image" aria-hidden="true">
            <div className="landing-page-text">
              <Link to="/smartbuilding" className="landing-nav-button">
                <h2
                  className="landing-nav-button-text"
                  dangerouslySetInnerHTML={{
                    __html:
                      textContentLandingPage.landingPage.domain.smartbuilding[
                        language
                      ],
                  }}
                />
                <img src={goRightIcon} aria-hidden="true" />
              </Link>
            </div>
            <img src={landingPageimageMobileSmartbuilding} aria-hidden="true" />
          </div>
          <div className="landing-page-image" aria-hidden="true">
            <div className="landing-page-text smarthome">
              <Link to="/smarthome" className="landing-nav-button left">
                <img src={goLeftIcon} aria-hidden="true" />
                <h2
                  className="landing-nav-button-text left"
                  dangerouslySetInnerHTML={{
                    __html:
                      textContentLandingPage.landingPage.domain.smarthome[
                        language
                      ],
                  }}
                />
              </Link>
            </div>
            <img src={landingPageimageMobileSmarthome} aria-hidden="true" />
          </div>
        </div>
      )}
    </>
  );
}

export default SmarthomePage;
